var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalyFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2230_43144)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2230_43144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74 0V20H1.64922C0.740333 20 0 19.2874 0 18.4196V1.58036C0 0.709422 0.740333 0 1.64922 0H9.74Z",
    fill: "#009246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2635 0V20H9.74023V0H20.2635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2637 20V0H28.3545C29.26 0 30.0004 0.709422 30.0004 1.58036V18.4196C30.0004 19.2874 29.26 20 28.3545 20H20.2637Z",
    fill: "#CE2B37"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2230_43144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2230_43144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalyFlag);
export default __webpack_public_path__ + "static/media/italy_flag.62ff59c8fe2be896eb8954bd852ef9b6.svg";
export { ForwardRef as ReactComponent };